import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconComputer = ({ color, overrides, ref, title, style }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Computer'
  color = color ?? theme.colors.primary

  return (
    <Icon viewBox='0 0 20 18' ref={ref} title={title} overrides={overrides} style={style}>
      <title>{title}</title>
      <path d="M8 15H2C1.45 15 0.979167 14.8042 0.5875 14.4125C0.195833 14.0208 0 13.55 0 13V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V13C20 13.55 19.8042 14.0208 19.4125 14.4125C19.0208 14.8042 18.55 15 18 15H12L13.85 16.85C13.8833 16.8833 13.9333 17 14 17.2V17.5C14 17.6333 13.95 17.75 13.85 17.85C13.75 17.95 13.6333 18 13.5 18H6.35C6.25 18 6.16667 17.9667 6.1 17.9C6.03333 17.8333 6 17.75 6 17.65V17.15C6 17.1167 6.03333 17.0333 6.1 16.9L8 15Z" fill={color}/>
    </Icon>
  )
}

IconComputer.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  title: PropTypes.string,
  style: PropTypes.object,
}

export default IconComputer
